'use client';

import { type SelectProps, Tooltip, type TooltipProps } from '@mui/material';
import React, { type ReactElement, useCallback, useState } from 'react';

type ControlledTooltipProps = Omit<TooltipProps, 'children'> & { disabled?: boolean } & (
		| { isSelectComponent: true; children: ReactElement<Pick<SelectProps, 'onOpen'>> }
		| { isSelectComponent?: false; children: TooltipProps['children'] }
	);

const ControlledTooltip = ({
	title,
	placement,
	arrow,
	disabled,
	isSelectComponent,
	children,
}: ControlledTooltipProps) => {
	const [open, setOpen] = useState(false);

	const handleSetOpen = useCallback(
		(value: boolean) => {
			if (disabled) return;
			setOpen(value);
		},
		[disabled],
	);

	const child = isSelectComponent ? React.cloneElement(children, { onOpen: () => setOpen(false) }) : children;

	return (
		<Tooltip
			title={title}
			placement={placement}
			arrow={arrow}
			open={open}
			disableHoverListener
			disableFocusListener
		>
			<div
				onMouseEnter={() => handleSetOpen(true)}
				onMouseLeave={() => handleSetOpen(false)}
				onClick={() => handleSetOpen(false)}
			>
				{child}
			</div>
		</Tooltip>
	);
};

export { ControlledTooltip };
